
let host ;
if (process.env.NODE_ENV === 'development') {
    host = 'http://localhost';
} else {
    host = 'https://app.infobiz.rs';
}

export default host;